import React, { useState, useEffect } from "react";
import {
    getPurchaseReceipt,
} from "../../service/api";
import { convertBase64ToArray, generateFileUrl } from '../../Utils/utils';
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
    linkText: {
        cursor: 'pointer',
        color: 'blue'
    }
  });

export default function PurchaseReceiptComponent(vin) {
    const classes = useStyles();
    const [pdfUrl, setPdfUrl] = useState(false);
        const getPurchaseReceiptData = async () => {
        const purchaseReceiptData = await getPurchaseReceipt(vin?.vin);
        const success = purchaseReceiptData?.data?.success;
        if(typeof success === 'string' && success?.toLowerCase() === 'true' )
        {
        setPdfUrl(true);    
        var sampleArr = convertBase64ToArray(purchaseReceiptData?.data?.receiptByte);
        const url = (generateFileUrl(sampleArr));
        const a = document.createElement('a')
        a.href = url
        a.download = 'PurchaseReceipt'
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        }
    }
    return (
       <>{pdfUrl && <span onClick={() => getPurchaseReceiptData()} className={classes.linkText}>Download</span>}</>
    );
}